
import { computed, ref, watch } from '@vue/composition-api';
import { RangeInput } from '05-ui-kit';
import debounce from 'lodash.debounce';
import type { FilterRange } from '~/type/Filter';
interface Props {
  name: string;
  initialToggle: boolean;
  filter: FilterRange;
  value: {
    [key: string]: string;
  };
}
const __sfc_main = {};
__sfc_main.props = {
  name: {
    key: "name",
    required: true,
    type: String
  },
  initialToggle: {
    key: "initialToggle",
    required: false,
    type: Boolean,
    default: false
  },
  filter: {
    key: "filter",
    required: true,
    type: null
  },
  value: {
    key: "value",
    required: true,
    type: Object
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const activeCount = ref(0);
  const debounceChange = debounce(change, 300);
  watch(() => props.value, val => {
    let count = 0;
    count += val[props.filter.from.property] && +val[props.filter.from.property] !== props.filter.min ? 1 : 0;
    count += val[props.filter.to.property] && +val[props.filter.to.property] !== props.filter.max ? 1 : 0;
    activeCount.value = count;
  }, {
    immediate: true
  });
  const minValue = computed(() => +props.value[props.filter.from.property] || props.filter.min || null);
  const maxValue = computed(() => +props.value[props.filter.to.property] || props.filter.max || null);
  function change(property: string, oldValue: number | null, newValue: number) {
    // Дополнительная проверка нужна для сравнения значений null и 0 как идентичных
    if (oldValue !== newValue && (oldValue === null || newValue === null ? !!oldValue !== !!newValue : true)) {
      emit('change', {
        property,
        value: String(newValue)
      });
    }
  }
  return {
    activeCount,
    debounceChange,
    minValue,
    maxValue
  };
};
__sfc_main.components = Object.assign({
  RangeInput
}, __sfc_main.components);
export default __sfc_main;
